<template>
	<div class="Footer">
		<div class="pageContent-w footer-content">
			<div class="boxItem">
				<h4>{{ $t('footer.contactUs') }}</h4>
				<div class="line">
					<div class="imgBox">
						<img src="@/assets/image/footer/email.png" alt="" class="img-list2" />
					</div>
					<span>{{ $t('footer.email') }} {{ dataInfo.email }}</span>
				</div>
				<div class="line">
					<div class="imgBox">
						<img src="@/assets/image/footer/name.png" alt="" class="img-list2" />
					</div>
					<span>{{ $t('footer.companyName') }} {{ dataInfo.companyName }}</span>
				</div>
				<div class="line">
					<div class="imgBox">
						<img src="@/assets/image/footer/phone.png" alt="" class="img-list2" />
					</div>
					<span>{{ $t('footer.tel') }} {{ dataInfo.phone }}</span>
				</div>
			</div>

			<!-- <div class="boxItem">
				<h4>{{ $t('footer.address') }}</h4>
				<div class="line">
					<div class="imgBox">
						<img src="@/assets/image/gpsIcon.png" alt="" class="img-list3" />
					</div>
					<span>{{ dataInfo.address }}</span>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ref } from 'vue'

const router = useRouter()

const dataInfo = ref({
	email: 'bulanadesixinggong@outlook.com',
	phone: '525624578306',
	address: '',
	companyName: 'BULANADESIXINGGONG',
	hours: '',
})
const goPage = (url) => {
	router.push(url)
}
</script>

<style lang="scss" scoped>
.Footer {
	background-color: #000;
	.footer-content {
		display: flex;
		flex-wrap: wrap;
		gap: 8rem;
		padding: 6rem 0;
		.boxItem {
			max-width: 33%;
			min-width: 20%;

			h4 {
				font-size: 2.6rem;
				font-weight: 500;
				margin-bottom: 3rem;
				color: #fff;
			}

			.line {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				margin: 1.2rem 0;
				color: #fff;
				span {
					display: inline-block;
					font-size: 1.8rem;
					line-height: 2.4rem;
				}

				.imgBox {
					height: 100%;
					.img-arrow {
						width: 1rem;
						margin-left: 0.8rem;
					}
					.img-list2 {
						width: 2.3rem;
						margin-right: 1.5rem;
					}
					.img-list3 {
						width: 1.6rem;
						margin-right: 1.5rem;
					}
				}
			}
			.cursor {
				cursor: pointer;
			}
		}
	}
}
</style>
